require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/modules/es7.symbol.observable.js
// module id = 1283
// module chunks = 3